export default "__VITE_ASSET__DoaegiMp__"